import type { FC, ReactNode } from "react";
import React, { Suspense } from "react";
import LocalErrorBoundary from "src/ui/components/SentryBoundary/LocalErrorBoundary";
import ErrorPage from "src/ui/components/SentryBoundary/ErrorPage";
import useBootScreenHold from "src/ui/hooks/useBootScreenHold";

/**
 * Renders nothing, but holds the boot screen while it is mounted — a lazy
 * chunk still in flight during boot would otherwise reveal an empty page.
 */
const SuspenseFallback: FC = () => {
  useBootScreenHold();
  return <div></div>;
};

const CustomSuspense: FC<{ children: ReactNode }> = (props) => {
  return (
    <LocalErrorBoundary fallback={<ErrorPage />}>
      <Suspense fallback={<SuspenseFallback />}>{props.children}</Suspense>
    </LocalErrorBoundary>
  );
};

export default CustomSuspense;
